// vue
import { useStore } from 'vuex'

// axios
import { AxiosPromise } from 'axios'

// hooks
import { useAuthHeader } from './auth-header'

export const useEventLogService = () => {
  // hooks
  const store = useStore()
  const authHeader = useAuthHeader()

  // properties
  const url = store.state.apiUrl

  // methods
  const getEventLog = async (envId, page = 1, accountId = 0, startDate = undefined, endDate = undefined): Promise<any[]> => {
    let dateParams = ''
    if (startDate) {
      dateParams = dateParams + `startDate=${startDate}&`
    }
    if (endDate) {
      dateParams = dateParams + `endDate=${endDate}`
    }
    const res = await authHeader.get(`${url}/environment/${envId}/event-log?page=${page}&accountId=${accountId}&` + dateParams)
    return res.data
  }

  const getErrorLog = async (envId, page = 1, accountId = 0, startDate = undefined, endDate = undefined): Promise<any[]> => {
    let dateParams = ''
    if (startDate) {
      dateParams = dateParams + `startDate=${startDate}&`
    }
    if (endDate) {
      dateParams = dateParams + `endDate=${endDate}`
    }
    const res = await authHeader.get(`${url}/environment/${envId}/error-log?page=${page}&accountId=${accountId}&` + dateParams)
    return res.data
  }

  return {
    getEventLog,
    getErrorLog
  }
}
